import { difference } from "lodash-es";
export function diffSchema(originSchema, targetSchema, options = {
  targetName: '目标数据'
}) {
  const {
    targetName
  } = options;
  // eslint-disable-next-line complexity
  function compareSchema(originSchema, targetSchema, parentKey = '') {
    const differences = [];
    if (originSchema.id && targetSchema.id && originSchema.id !== targetSchema.id) {
      differences.push(`${parentKey} 在原数据中未定义`);
    }
    if (originSchema.type !== targetSchema.type) {
      differences.push(`${parentKey} 真实类型为 ${originSchema.type}，但${targetName}里为 ${targetSchema.type}`);
    }
    if (originSchema.type === 'object' && targetSchema.type === 'object') {
      if (!originSchema.fields && targetSchema.fields) {
        differences.push(`${parentKey} 在原数据中fields为空，但${targetName}中fields不为空`);
      } else if (originSchema.fields && !targetSchema.fields) {
        differences.push(`${parentKey} 在原数据中fields不为空，但${targetName}中fields为空`);
      } else if (originSchema.fields && targetSchema.fields) {
        const targetSchemaIds = targetSchema.fields.map(item => item.id);
        const originSchemaIds = originSchema.fields.map(item => item.id);
        const idsDeleted = difference(originSchemaIds, targetSchemaIds);
        const idsAdded = difference(targetSchemaIds, originSchemaIds);
        if (idsDeleted !== null && idsDeleted !== void 0 && idsDeleted.length) {
          differences.push(`${parentKey} ${targetName}比原数据中缺少这些字段 ${idsDeleted.join('、')}`);
        }
        if (idsAdded.length) {
          differences.push(`${parentKey} ${targetName}比原数据中多出这些字段 ${idsAdded.join('、')}`);
        }
        for (const field of originSchema.fields) {
          const key = parentKey ? `${parentKey}.${field.id}` : String(field.id);
          // if (!targetSchemaFieldsIds.includes(field.id)) {
          //   messages.push(`${key} 在${targetName}中缺失`);
          //   continue;
          // }
          const targetField = targetSchema.fields.find(item => item.id === field.id);
          if (!targetField) {
            continue;
          }
          const fieldMessage = compareSchema(field, targetField, key);
          differences.push(...fieldMessage);
        }
      }
    }
    if (originSchema.type === 'array' && targetSchema.type === 'array') {
      if (!originSchema.items && targetSchema.items) {
        differences.push(`${parentKey} 在原数据中items为空，但${targetName}中items不为空`);
      } else if (originSchema.items && !targetSchema.items) {
        differences.push(`${parentKey} 在原数据中items不为空，但${targetName}中items为空`);
      } else if (originSchema.items && targetSchema.items) {
        const newArrayKey = `${parentKey}[items]`;
        const arrayMessages = compareSchema(originSchema.items, targetSchema.items, newArrayKey);
        differences.push(...arrayMessages);
      }
    }
    return differences;
  }
  const differences = compareSchema(originSchema, targetSchema);
  return {
    hasDifferences: differences.length > 0,
    isEqual: differences.length <= 0,
    differences
  };
}
//# sourceMappingURL=diffSchema.js.map
